import { create } from 'zustand'

import { MASS_CHANNEL, IDLE } from './types'
import type { ChannelState, MassChannel } from './types'

interface MassActionState {
  channels: Record<MassChannel, ChannelState>
  setChannel: (channel: MassChannel, state: ChannelState) => void
  resetChannel: (channel: MassChannel) => void
  resetAll: () => void
}

const INITIAL_CHANNELS: Record<MassChannel, ChannelState> = {
  [MASS_CHANNEL.sms]: IDLE,
  [MASS_CHANNEL.email]: IDLE,
  [MASS_CHANNEL.phone]: IDLE,
}

export const useMassActionStore = create<MassActionState>()((set) => ({
  channels: INITIAL_CHANNELS,
  setChannel: (channel, state) =>
    set((prev) => ({ channels: { ...prev.channels, [channel]: state } })),
  resetChannel: (channel) =>
    set((prev) => ({ channels: { ...prev.channels, [channel]: IDLE } })),
  resetAll: () => set({ channels: INITIAL_CHANNELS }),
}))
